import { Loader } from '../../components';
import { memo, useEffect } from 'react';
import { useActiveLoan } from 'pages/ActiveLoan/useActiveLoan';
import { useApplication } from '../../hooks/webapi';
import FullRepaymentDefault from './FullRepaymentDefault';
import FullRepaymentOverdue6Or8 from './FullRepaymentOverdue6Or8';
import useLatestLoan from '../../hooks/webapi/useLatestLoan';

export default memo(function FullRepayment() {
  const { isOverdue, isBrokenAgreement } = useActiveLoan();
  const { application } = useApplication();
  const { latestLoan, selectedLoanExtension, setSelectedLoanExtension } =
    useLatestLoan();

  useEffect(() => {
    if (selectedLoanExtension) setSelectedLoanExtension(undefined);
  }, [selectedLoanExtension]);

  if (!application || !latestLoan) return <Loader />;

  if (isOverdue || isBrokenAgreement) return <FullRepaymentOverdue6Or8 />;

  return <FullRepaymentDefault />;
});
